import { Component, Input } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StudyManagerModule } from '../../study-manager.module';

@Component({
    selector: 'jhi-advance-study-modal',
    standalone: true,
    imports: [
        NgSelectModule,
        TranslateModule,
        StudyManagerModule
    ],
    templateUrl: './advance-study-modal.component.html',
    styleUrl: './advance-study-modal.component.scss'
})
export class AdvanceStudyModalComponent {

    @Input() studyId: any;
    @Input() selectedInstances: any[];
    @Input() replicationNumber: number;
    @Input() selectedDatasetId: number;

    constructor(private activeModal: NgbActiveModal) {}

    closeModal() {
        this.activeModal.dismiss();
    }
}
